// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/agent-performance/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/agent-performance/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Đã sao chép" })
  return <Page />
}
